module.exports = __webpack_public_path__ + "static/5-76570c2c39b0c64d4cf0877ea98426e6.jpeg";